// extracted by mini-css-extract-plugin
module.exports = {"paginatedListWrapper":"PaginatedList_paginatedListWrapper__GPNbw"};